// extracted by mini-css-extract-plugin
module.exports = {"PatternsView":"PatternsView_PatternsView__2jC3a"};